import Image from "next/image";

export default function ConsultParts() {
  return (
    <section className="">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-2xl font-semibold text-gray-900">
            CONHEÇA AS PEÇAS
            <br />
            GENUÍNAS TOYOTA
          </h2>
        </div>

        <div className="flex justify-center lg:grid-cols-3 gap-8 items-center">
          <div className="lg:col-span-1 flex justify-center">
            <a
              href="https://www.pecasredetoyota.com.br/home"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-red-600 hover:bg-red-700 text-white px-8 py-6 rounded-md text-lg text-center relative animate-pulse overflow-hidden
                before:content-[''] before:absolute before:top-0 before:left-[-100%] before:w-full before:h-full 
                before:bg-gradient-to-r before:from-transparent before:via-white/20 before:to-transparent
                before:animate-[shine_3s_infinite]"
            >
              CONSULTE AS PEÇAS
              <br />
              DO SEU VEÍCULO
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
